export default "/images/vendor/flag-icon-css/flags/4x3/cd.svg?e5fd4d1225cc6c53b73d7b6f037aafeb";